module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_shiromuku-3cc821c5103bbbfc51e6f1f18016fc7a.webp";